import { render, staticRenderFns } from "./NormalDialog.vue?vue&type=template&id=c0ed5aa6&scoped=true"
import script from "./NormalDialog.vue?vue&type=script&lang=js"
export * from "./NormalDialog.vue?vue&type=script&lang=js"
import style0 from "./NormalDialog.vue?vue&type=style&index=0&id=c0ed5aa6&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c0ed5aa6",
  null
  
)

export default component.exports